import React from 'react';
import styles from './MainSlider.module.scss';

const MainSliderItem = ({ children }) => {
  return <div className={styles.item}>{children}</div>;
};

export default MainSliderItem;
